import { Box, Button, Image, Stack, Text, VStack } from "@chakra-ui/react";
import React from "react";
import { Icon } from "../../../content/Content";
import LeftChat from "./components/leftChat";
import ChatApplication from "./components/ChatApplication";
import RightChat from "./components/RightChat";
import './Chat.component.css'
const Chat = () => {
  return (
    <VStack w="100%" bg="#F5F5FF">
      {/* Top bar */}
      <Stack
        w={{ base: "100%", sm: "100%", md: "95%", lg: "90%", xl: "90%" }}
        pt="90px"
      >
        <Stack flexDir="row" w="100%">
          <Box w="50%">
            <Text
              fontFamily="'Roboto',sans-serif"
              fontSize="40px"
              fontWeight="700"
              textAlign="left"
              ml="10px"
            >
              Chat
            </Text>
          </Box>
          <Box w="50%" display="flex" justifyContent="flex-end">
            <Button
              color="#fff"
              bg="#000000"
              borderRadius="6px"
              fontFamily="'Roboto',sans-serif"
              fontSize="14px"
              fontWeight="600"
              textAlign="center"
              _hover={{ backgroundColor: "#000000" }}
              display="flex"
              alignItems="center"
            >
              Import <Image src={Icon.importIcon} ml="5px" />
            </Button>
            <Button
              mx="8px"
              color="#fff"
              bg="#000000"
              borderRadius="6px"
              fontFamily="'Roboto',sans-serif"
              fontSize="14px"
              fontWeight="600"
              textAlign="center"
              _hover={{ backgroundColor: "#000000" }}
            >
              Export <Image src={Icon.exportIcon} ml="5px" />
            </Button>
          </Box>
        </Stack>

        <Stack w="100%" flexDir="row">
            <Box w="25%">
               <LeftChat/>
            </Box>
            <Box w="50%">
                <ChatApplication/>
            </Box>
            <Box w="25%">
                <RightChat/>
            </Box>
        </Stack>
      </Stack>
    </VStack>
  );
};

export default Chat;
